// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8b3fc73f","453":"8b344bad"}[chunkId] + ".chunk.js";
};